import _user from "./../../levels/common.blocks/user2/user2.react.js";

var User = _user.applyDecls();

import "./../../levels/common.blocks/user2/user2.css";
import "./../../levels/desktop.blocks/user2/user2.css";


export default User;